module.exports = __webpack_public_path__ + "static/media/confetti.737fc4c5.gif";